export default "__VITE_ASSET__DiNrQECk__"